import { render, staticRenderFns } from "./QStudioIntroduce.vue?vue&type=template&id=3764b6a3&scoped=true&"
import script from "./QStudioIntroduce.vue?vue&type=script&lang=js&"
export * from "./QStudioIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./QStudioIntroduce.vue?vue&type=style&index=0&id=3764b6a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3764b6a3",
  null
  
)

component.options.__file = "QStudioIntroduce.vue"
export default component.exports